const PrivacyPolicy = ({ onAccept }) => {
  console.log("Rendering PrivacyPolicy..."); // Debugging log
  return (
    <div className="modal">
      <h2>Privacy Policy</h2>
      <p>
        By using this platform, you agree to the use of your camera and microphone
        for video consultations. Please review our full privacy policy before proceeding.
      </p>
      <button onClick={onAccept}>I Accept</button>
    </div>
  );
};

export default PrivacyPolicy;
